import { CONFLUENCE_ORIGIN } from "./constants";

export const getPageIdFromHref = (href) => {
    if (!href) {
        return null;
    }

    try {
        const url = new URL(href, CONFLUENCE_ORIGIN);
        const pageMatch = url.pathname.match(/\/pages\/(\d+)\//) || url.pathname.match(/\/content\/(\d+)/);

        if (pageMatch) {
            return pageMatch[1];
        }

        return url.searchParams.get("pageId");
    } catch (error) {
        return null;
    }
};
